import React, { useEffect } from "react";
import avatar from "@src/assets/images/img/avatar.jpg";
import { getCommentByBlog } from "@store/action/smartend/CommentAction";
import { useSelector } from "react-redux";
import { useRouteMatch, useParams } from "react-router-dom";
import CommentForm from "./CommentForm";

const Comment = ({ t, dispatch }) => {
  const { id } = useParams();
  const myURL = "/" + useRouteMatch().params.webmasterTitle;
  const store = useSelector((state) => state.CommentReducer);
  useEffect(() => {
    dispatch(getCommentByBlog(myURL, id));
  }, [store?.data?.length, id]);
  const toggleText = (i) => {
    let showMoreText = document.getElementById(`moreText-${i}`);
    let buttonText = document.getElementById(`textButton-${i}`);
    if (buttonText.innerHTML === "Show Less") {
      showMoreText.style["white-space"] = "nowrap";
      buttonText.innerHTML = t("show more");
    } else {
      showMoreText.style["white-space"] = null;
      buttonText.innerHTML = t("Show Less");
    }
  };
  var arr = [];
  useEffect(() => {
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index];
      const moreText = document.getElementById(`moreText-${element}`);
      const textButton = document.getElementById(`textButton-${element}`);
      if (moreText.offsetWidth < moreText.scrollWidth) {
        textButton.classList.remove("d-none");
      }
    }
  }, [arr]);

  return (
    <div className="leave_comment_wrapper ms_cover">
      <div className="ms_heading_wrapper leave_comment_heading">
        <h1>{t("leave a comment")}</h1>
      </div>
      <div className="comment_heading_top ms_cover mb-1">
        <p>
          {store?.Comments_count} {t("comments")}
        </p>
      </div>
      {store?.data
        ?.filter((el) => el.status === 1)
        .map((item, i) => {
          {
            arr.push(i);
          }
          return (
            <div className="comments_Box" key={i}>
              <div className="img_wrapper">
                <img src={item.avatar ? item.avatar : avatar} width="120px" className="" alt="author_img" />
              </div>
              <div className="text_wrapper">
                <div className="author_detail">
                  <span className="author_name"> {item.name}</span>
                  <span className="publish_date">
                    {new Date(item.created_at).toLocaleString()} -
                  </span>
                </div>
                <div
                  className="author_content"
                  style={{ overflowWrap: "break-word", padding: "15px" }}
                >
                  <p
                    id={`moreText-${i}`}
                    style={{
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                    }}
                  >
                    {item.comment}
                  </p>
                  <p
                    style={{ color: "blueviolet" }}
                    onClick={() => {
                      toggleText(i);
                    }}
                    className="cursor-pointer d-none"
                    id={`textButton-${i}`}
                  >
                    {t("show more")}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      <CommentForm t={t} dispatch={dispatch} />
    </div>
  );
};

export default Comment;
